import React, { useState } from "react";
import { Modal, Box, TextField, Button, Typography } from "@mui/material";
import { updateUserProfile } from "../../api";   // <-- εδώ

const defaultForm = { name: "", email: "", phone: "", location: "" };

const AppointmentForm = ({
  open,
  onClose,
  sessionId,
  onSuccess
}) => {
  const [form, setForm] = useState(defaultForm);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.name || !form.email || !form.phone || !form.location) {
      setError("Συμπληρώστε όλα τα πεδία.");
      return;
    }
    setLoading(true);
    try {
      await updateUserProfile({ session_id: sessionId, ...form });  // <-- εδώ
      setForm(defaultForm);
      setLoading(false);
      onSuccess(form);
      onClose();
    } catch {
      setError("Σφάλμα κατά την αποθήκευση.");
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: "#fff", p: 4, borderRadius: 3, boxShadow: 24, minWidth: 320
      }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>Στοιχεία Ραντεβού</Typography>
        <form onSubmit={handleSubmit}>
          <TextField label="Όνομα" name="name" value={form.name} onChange={handleChange} fullWidth sx={{ mb: 2 }} />
          <TextField label="Email" name="email" value={form.email} onChange={handleChange} fullWidth sx={{ mb: 2 }} />
          <TextField label="Τηλέφωνο" name="phone" value={form.phone} onChange={handleChange} fullWidth sx={{ mb: 2 }} />
          <TextField label="Τοποθεσία ή Ταχ. Κώδικας" name="location" value={form.location} onChange={handleChange} fullWidth sx={{ mb: 2 }} />
          {error && <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>}
          <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
            Συνέχεια
          </Button>
        </form>
      </Box>
    </Modal>
  );
};

export default AppointmentForm;
